import React, { memo } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Phone from "./Phone";
import NotFound from "../../../../../Common/NotFound";

const PhoneDetails = memo(({ customer }) => {
	return (
		<div className="row">
			{_.some(customer.phones) ? (
				customer.phones.map((phone, index) => {
					return (
						<div className="col-xs-6" key={index}>
							<Phone phone={phone} />
						</div>
					);
				})
			) : (
					<NotFound>No phone numbers found for this customer...</NotFound>
				)}
		</div>
	);
});
PhoneDetails.displayName = `PhoneDetails`;
PhoneDetails.propTypes = {
	customer: PropTypes.object.isRequired
};

export default PhoneDetails;
